var chipLabel = 'fx_e395032e_in7h9q1';
var chipLabelHorizontalGap = 'var(--fx_e395032e_in7h9q0)';

export { chipLabel, chipLabelHorizontalGap };
//# sourceMappingURL=label.vanilla.mjs.map
